import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {environment} from '../../environments/environment';
import CalendarModel from "../../model/calendar.model";
import QueryEncoder from "../queryEncoder";
import EventModel from "../../model/event.model";
import VacationModel from "../../model/vacation.model";
import CalendarDayModel from "../../model/calendarDay.model";

@Injectable()
export default class CalendarService {
  public constructor(private http: HttpClient) {
  }
  public month(date: Date, additional?: any): Observable<CalendarDayModel[]> {
    let params = {
        date: date.toISOString()
    };
    if(additional) {
        Object.assign(params, additional);
    }

    let queryArr = [];
    for(let key of Object.keys(params)) {
        queryArr.push(key + '=' + params[key]);
    }
    return this.http.get<CalendarDayModel[]>(environment.apiUrl + '/calendar/month?' + queryArr.join('&'));
  }
  public list(year, month, additionalInfo?: any): Observable<any[]> {
    return this.http.get<any[]>(environment.apiUrl + '/calendar/list/' + year + '/' + month + '?' + QueryEncoder.encodeURI(additionalInfo));
  }
  public dayEvents(year, month, day, additionalInfo?: any): Observable<any[]> {
    return this.http.get<any[]>(environment.apiUrl + '/calendar/day-events/' + year + '/' + month + '/' + day + '?' + QueryEncoder.encodeURI(additionalInfo));
  }
  public createPrivateEvent(event: EventModel): Observable<EventModel> {
    return this.http
        .post<EventModel>(environment.apiUrl + '/calendar/create-private-event', event);
  }
  public createVacation(event: EventModel): Observable<VacationModel> {
    return this.http
        .post<VacationModel>(environment.apiUrl + '/calendar/create-vacation', event);
  }
  public showPrivateEvent(id): Observable<EventModel> {
    return this.http.get<EventModel>(environment.apiUrl + '/calendar/private-event/' + id);
  }
  public showVacation(id): Observable<VacationModel> {
    return this.http
        .get<VacationModel>(environment.apiUrl + '/calendar/vacation/' + id);
  }

}
